<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter">Contents<br/><br/><br/></p>
<p class="toc"><a href="#/OEBPS/06prologue.htm">Prologue</a></p>
<p class="toc"><a href="#/OEBPS/07intro.htm">Introduction</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/ch01.htm"><span class="small">CHAPTER</span> 1<br/>
Little White Coffins</a></p>
<p class="toc"><a href="#/OEBPS/ch02.htm"><span class="small">CHAPTER</span> 2<br/>
Back to the Drawing Board</a></p>
<p class="toc"><a href="#/OEBPS/ch03.htm"><span class="small">CHAPTER</span> 3<br/>
The Grand Experiment</a></p>
<p class="toc"><a href="#/OEBPS/ch04.htm"><span class="small">CHAPTER</span> 4<br/>
How Does It Feel to Be a Killer of Children?</a></p>
<p class="toc"><a href="#/OEBPS/ch05.htm"><span class="small">CHAPTER</span> 5<br/>
A Man-Made Polio Epidemic</a></p>
<p class="toc"><a href="#/OEBPS/ch06.htm"><span class="small">CHAPTER</span> 6<br/>
What Went Wrong at Cutter Laboratories</a></p>
<p class="toc"><a href="#/OEBPS/ch07.htm"><span class="small">CHAPTER</span> 7<br/>
Cutter in Court</a></p>
<p class="toc"><a href="#/OEBPS/ch08.htm"><span class="small">CHAPTER</span> 8<br/>
Cigars, Parasites, and Human Toes</a></p>
<p class="toc"><a href="#/OEBPS/ch09.htm"><span class="small">CHAPTER</span> 9<br/>
Death for the Lambs</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/epilog.htm">Epilogue</a></p>
<p class="toc"><a href="#/OEBPS/notes.htm">Notes</a></p>
<p class="toc"><a href="#/OEBPS/bib.htm">Selected Bibliography</a></p>
<p class="toc"><a href="#/OEBPS/ack.htm">Acknowledgments</a></p>
<p class="toc"><a href="#/OEBPS/index.htm">Index</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05content.vue?0efba23e